import matches from './matches/initialState';
import messages from './messages/initialState';
import passport from './passport/initialState';
import preferences from './preferences/initialState';
import settings from './settings/initialState';
import unmatchedIds from './unmatchedIds/initialState';

const initialState = {
  matches,
  messages,
  passport,
  preferences,
  settings,
  unmatchedIds,
};

export default initialState;
